const getters = {
    navs: state => state.user.navs,
    userInfo: state => state.user.userInfo,
}
export default getters
